import $ from "jquery";

$(document).ready(function ()  {
    $("#DateOfBirth").datepicker({
        format: 'dd/mm/yyyy',
        maxDate: ("-5Y"),
        minDate: ("-150Y")
    });
});

const fieldId = "EmailAddressClone";

const copyEmailValue = () => {
    const elem = document.getElementById(fieldId);
    const src = document.getElementById("EmailAddress");
    elem.value = src.value;
    $(elem).change();
};

const init = () => {

    if (window.location.pathname !== "/Register") return;

    copyEmailValue();
    const src = document.getElementById("EmailAddress");
    src.addEventListener("keyup", copyEmailValue);
};

document.addEventListener("DOMContentLoaded", init);
